import { memo, ReactNode } from 'react'

import { Id } from '../types'

export const cellHeightStyle = {
    short: 34,
    medium: 64,
    tall: 80,
} as const

export type CellHeight = keyof typeof cellHeightStyle

export type BodyProps<TRow extends { id: Id }> = {
    children: (row: TRow, rowHeight: number) => ReactNode
    rowHeight: number
    start: number
    end: number
    rows: TRow[]
}

function BodyComponent<TRow extends { id: Id }>({ rowHeight, start, end, rows, children }: BodyProps<TRow>) {
    const topPadding = start * rowHeight
    const bottomPadding = (rows.length - end) * rowHeight
    const visibleRows = rows.slice(start, end)

    return (
        <>
            {topPadding > 0 && <div style={{ height: topPadding }} />}
            {visibleRows.map(row => children(row, rowHeight))}
            {bottomPadding > 0 && <div style={{ height: bottomPadding }} />}
        </>
    )
}

export const TableBody = memo(BodyComponent) as typeof BodyComponent
